import { IRowActionMenuProps } from './interface'
import React, { useCallback } from 'react'
import { Button, Dropdown, Popconfirm } from 'antd'
import type { MenuProps } from 'antd'
import { MoreOutlined, DeleteTwoTone } from '@ant-design/icons'
import { ButtonActionWrapper } from '../app-chat/styles'


export function RowActionMenu({ id, deleteRecord }: IRowActionMenuProps) {
  const handleDelete = useCallback(() => deleteRecord(id), [deleteRecord, id])

  const menuItems: MenuProps['items'] = [
    {
      key: 'delete',
      label: (
        <Popconfirm
          title="Вы уверены, что хотите удалить эту запись?"
          okText="Да"
          cancelText="Нет"
          onConfirm={handleDelete}
        >
          <span>Удалить</span>
        </Popconfirm>
      ),
    },
  ]

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
      <Button
        type="default"
        icon={<MoreOutlined style={{ fontSize: 16 }} />}
        title="Действия"
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  )
}